"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/FocusTrapZone/index"), exports);
//# sourceMappingURL=FocusTrapZone.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/FocusTrapZone.js
// module id = 630
// module chunks = 0